import { RegexConstants } from '@/constants/regex';

export const toAriaLabelText = (text?: string) => {
    if (!text) return '';

    return text.replace(RegexConstants.HTML_TAG, ' ').replace(RegexConstants.MULTIPLE_SPACES, ' ').trim();
};
